












































































// @ is an alias to /src
import { Component, Vue } from 'vue-property-decorator'
import { AloForfait, getDefaultAloForfait } from '@/models/alo/AloForfait'
import { VuetifyConfirmObject } from '@/plugins/confirm/types'
import {DashboardAdmin} from '@/router/pages'

@Component({
  name: 'GestionForfait'  
})
export default class GestionForfait extends Vue {
  private loading = false
  private showError = false  
  private showNew = false
  private newForfait = getDefaultAloForfait()
  private defaultHeaderHeight = 90
  mounted() {
    this.defaultHeaderHeight = 5
  }

  get tableauHeight(){
    //@ts-ignore
    return this.$store.myGetters.contentHeight - ((this.$refs?.header?.clientHeight+this.defaultHeaderHeight)??this.defaultHeaderHeight)
  }

  private headers = [
    { text: 'ID', value: 'id', width:70 },    
    { text: 'En vente', value: 'fftEnable', width:90 },
    { text: 'Titre', value: 'libelle', width:200, },
    { text: 'Tarif', value: 'fftTarif', width:80, },
    { text: 'Activités possible', value: 'acyIds' },
    { text: 'Piscines concernées', value: 'psnIds' },
    { text: '', value:'actions', width:30, sortable:false,filterable:false}
  ]

  private get forfaitList() {
    return this.$store.myGetters.forfaitList
  }

  private get search(){
    return this.$store.myGetters.searchForfait
  }
  private set search(value){
    this.$store.myActions.UI_SET_SEARCH_FORFAIT(value)
  }

  private get sortDesc(){
    return this.$store.myGetters.sortForfaitDesc
  }
  private set sortDesc(value){
    this.$store.myActions.UI_SET_SORT_FORFAIT_DESC(value)
  }

  private get sortBy(){
    return this.$store.myGetters.sortForfaitBy
  }
  private set sortBy(value){
    this.$store.myActions.UI_SET_SORT_FORFAIT_BY(value)
  }

  private get activityDic(){
    return this.$store.myGetters.activityDic
  }

  private get piscineDic(){
    return this.$store.myGetters.piscineDic 
  }

  

    
  created() {
    this.$store.myActions.ADM_ACTIVITY_ENSURE();
    this.$store.myActions.ADM_PISCINE_ENSURE();
    this.loading = true    
    this.$store.myActions.ADM_FORFAIT_ENSURE().finally(() => {
      this.loading = false
    })
  }


  openDetail(item: any) {
    this.$router.push({name:'ModifyForfait',params:{forfaitId:item.id}})    
  }

  deleteForfait(forfait:AloForfait) {
     if(forfait.id != 0) {      
       this.$confirm(`Voulez vous vraiment supprimer la forfait "${forfait.libelle}" ?`,{title: "Attention"} as VuetifyConfirmObject).then((answer) => {
        if (answer) {          
          this.$store.myActions.ADM_FORFAIT_DELETE_REQUEST(forfait.id)
        } 
      })          
    } 
  }

  addForfait(){
    this.showNew = true  
    this.newForfait = getDefaultAloForfait()
  }

  save(){
    this.$store.myActions.ADM_FORFAIT_SAVE_REQUEST(this.newForfait).then((forfait)=>{
      this.showNew = false
      this.openDetail(forfait)
    })    
  }

  get arianeItems() {
    return  [
        DashboardAdmin,
        {
          text: 'Activités',
          disabled: true,  
          to: {name:'AdminForfait'},        
          exact:true
        }
      ]      
  } 
 
}
